module.exports = __webpack_public_path__ + "img/database.962ff1ac.png";